export default __webpack_public_path__ + "static/media/ladybug.324ca6ca.png";